import React from 'react';
import { FolderOpenOutlined, PlayCircleOutlined, PictureOutlined } from '@ant-design/icons';
import { BaseCardContent } from '../MessageType';

interface ArtifactCardViewProps {
  content: BaseCardContent;
}

export const ArtifactCardView: React.FC<ArtifactCardViewProps> = ({ content }) => {
  const artifactType = (content.artifactType as string) || 'image';
  const count = Number(content.count) || 0;
  const isVideo = artifactType === 'video';

  const gradient = isVideo
    ? 'linear-gradient(135deg, #FF3B30, #FF8E7B)'
    : 'linear-gradient(135deg, #FF6B35, #FFB347)';

  const icon = isVideo ? (
    <PlayCircleOutlined style={{ fontSize: 28, color: '#fff' }} />
  ) : (
    <PictureOutlined style={{ fontSize: 28, color: '#fff' }} />
  );

  return (
    <div className="message-artifact-card" style={{ background: gradient }}>
      <div className="message-artifact-icon">{icon}</div>
      <div className="message-artifact-info">
        <div className="message-artifact-title">
          <FolderOpenOutlined style={{ marginRight: 6 }} />
          作品集
        </div>
        <div className="message-artifact-count">
          共{count}个{isVideo ? '视频' : '图片'}作品
        </div>
      </div>
    </div>
  );
};
